import React, { memo } from 'react';

import TableWidget from '~/core/scripts/widgets/TableWidget';
import { numberFormat } from '~/core/scripts/utils';

const sleepingColumns = [
  {
    title: 'Urlaubsregion',
    dataIndex: 'table_name',
    className: 'region',
  },
  {
    title: 'pro 100.000',
    dataIndex: 'agsRel',
    render: function (val) {
      return numberFormat(val, 2);
    },
    className: 'value',
  },
  {
    title: 'seit Ferienbeginn',
    dataIndex: 'agsDelta',
    render: function (val) {
      return isNaN(val) || !isFinite(val) ? '↗\uFE0E' : (val === -9999999999) ? '↘\uFE0E' : (val === 0 ? '±' : val > 0 ? '+' : '') + numberFormat(val, 0, '%');
    },
  },
];

const infectionColumns = [
  {
    title: 'Urlaubsregion',
    dataIndex: 'table_name',
    className: 'region',
  },
  {
    title: 'pro 100.000',
    dataIndex: 'agsRel',
    render: function (val) {
      return numberFormat(val, 2);
    },
    className: 'value',
  },
  {
    title: 'seit Ferienbeginn',
    dataIndex: 'agsDelta',
    render: function (val) {
      return isNaN(val) || !isFinite(val) ? '↗\uFE0E' : (val === -9999999999) ? '↘\uFE0E' : (val === 0 ? '±' : val > 0 ? '+' : '') + numberFormat(val, 0, '%');
    },
  },
];

const columns = {
  sleepings: sleepingColumns,
  infections: infectionColumns,
};

export default memo(({ data, colorScale, dataMode, onHoverCell }) => {
  return (
    <TableWidget
      columns={columns[dataMode]}
      data={data}
      showRank
      compactButtonLabel="Top 10"
      rowKey="table_name"
      colorScale={colorScale}
      rowBgColorKey="agsRel"
      rankColor="rgba(0,0,0,0.5)"
      rankFontColor="white"
      striped={false}
      rowClassColumn="row"
      dataMode={dataMode}
      onHoverCell={onHoverCell}
      useFixedHeader={true}
    />
  );
});
